import Login from "../../layouts/Login";
import { LoginType } from "../../utils/Common";
function StudentLogin() {
  return <Login type={LoginType.STUDENT} />;
}
export default StudentLogin;
